// Manual review step shown after the privacy pipeline (OVH) finishes and before
// the OpenAI quote/anecdote extraction runs. The user can fix anything the
// automatic redaction missed before clicking Opslaan.
const TranscriptReview = ({ transcript, setTranscript, onSave }) => (
  <div className="transcript-review">
    <h3 className="transcript-review-title">Controleer de transcriptie</h3>
    <p className="transcript-review-hint">
      De privacyfilters zijn toegepast. Controleer of er nog persoonsgegevens in
      staan en pas ze zo nodig handmatig aan. Pas na het opslaan wordt de tekst
      geanalyseerd.
    </p>
    <textarea
      className="transcript-review-textarea"
      value={transcript}
      onChange={(e) => setTranscript(e.target.value)}
      rows={14}
    />
    <button className="transcript-review-save" onClick={onSave}>
      Opslaan
    </button>
  </div>
);

export default TranscriptReview;
